<template>
  <div>
    <v-row class="ma-0">
      <v-btn small>問{{ !$route.params.id ? Number(no) + 1 : Number(no) }}</v-btn>
    </v-row>
    <v-row class="mx-0 mt-2 lead-sentence">
      <span class>{{ formGeneral.leadSentence }}</span>
    </v-row>
    <v-row class="mx-0 mt-5" justify="center">
      <audio
        class="ml-3"
        ref="audioTemplate"
        :key="`Template-${keyAudio}`"
        v-if="formGeneral.audio && formGeneral.audio.fileUrl"
      >
        <source :src="formGeneral.audio.fileUrl" type="audio/mp3" />
        Your browser does not support the audio element.
      </audio>
      <v-btn color="warning" fab x-large dark @click="play">
        <v-icon v-if="!formGeneral.audio">fas fa-volume-off</v-icon>
        <v-icon v-if="formGeneral.audio && formGeneral.audio.fileUrl"
          >fas fa-volume-up</v-icon
        >
      </v-btn>
    </v-row>
    <v-row class="mx-0 mt-5">
      <v-col
        :cols="!checkLength ? 6 : 12"
        v-for="(answers, index) in formGeneral.answers"
        :key="index"
      >
        <button class="width-10 pa-1 grey lighten-4 button-template">
          {{ answers.value ? answers.value : answers.name }}
        </button>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: ["no"],
  store: ["formGeneral"],
  data() {
    return {
      keyAudio: 0,
    };
  },
  watch: {
    "formGeneral.audio": function () {
      this.keyAudio++;
    },
  },
  computed: {
    checkLength() {
      return Boolean(this.formGeneral.answers.find((e) => e.value.length > 9));
    },
  },
  methods: {
    play() {
      if (this.$refs.audioTemplate.paused) {
        this.$refs.audioTemplate.play();
      } else {
        this.$refs.audioTemplate.pause();
      }
    },
  },
};
</script>
<style scoped>
.lead-sentence {
  white-space: pre-wrap;
  padding-bottom: 8px;
  border-bottom: 5px dotted #feb798;
}
button {
  word-wrap: break-word;
}
</style>